import { useSyncExternalStore } from "react";

/**
 * The lines the console adds to an open chat by itself, in the thread like v2.20's system notes: 「weijian 接手了，
 * 小爱先不说话」 after 人工回复, 「交回小爱，她接着回」 after 小爱回复. The header's buttons add them (addChatNote) and the
 * thread draws them (useChatNotes) after the messages, by the time they were added. They live for this visit only: the
 * server's transcript is what stays.
 */
export type ChatNote = { id: number; at: number; text: string };

const notes = new Map<string, ChatNote[]>();
const listeners = new Set<() => void>();
const NONE: ChatNote[] = [];
let seq = 0;

export function addChatNote(waId: string, text: string) {
  notes.set(waId, [...(notes.get(waId) ?? NONE), { id: ++seq, at: Date.now(), text }]);
  listeners.forEach((f) => f());
}

const listen = (f: () => void) => {
  listeners.add(f);
  return () => {
    listeners.delete(f);
  };
};

/** The notes added to this chat on this visit, oldest first. */
export function useChatNotes(waId: string | null | undefined): ChatNote[] {
  return useSyncExternalStore(listen, () => (waId ? (notes.get(waId) ?? NONE) : NONE));
}
